import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {PopoverController} from '@ionic/angular';
import {FormFieldType, IndFormFieldViewDataModel} from '@omni/models/indFormFieldDataModel';
import { isEmpty } from 'lodash-es';
@Component({
  selector: 'alert-with-input',
  templateUrl: 'alert-with-input.html',
  styleUrls: ['alert-with-input.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertWithInput implements OnInit {
  @Input() inputs: any;
  @Input() header: string;
  @Input() message: string
  @Input() Placeholder: string
  @Input() cancelText;
  @Input() confirmText;
  @Input() isMandatory: boolean;
  selectedItem: any;
  @Input() selectedOtherItem: string;
  @Input() enableMultiSelect:boolean = false;
  @Input() customFormField: IndFormFieldViewDataModel;
  public enableOtherItemTextBox:boolean = false;
  @Input() requireDescriptionForOthers: boolean = false;

  constructor(
    private popoverCtrl: PopoverController,
  ) {


  }

  onSelectOption(ev) {
    this.selectedItem = ev;
    if (this.selectedItem != 'Others') {
      this.selectedOtherItem = null;
    }
  }

  onMultiSelectOption(ev){
    if(ev['isSelected']){
      ev['isSelected'] = !ev['isSelected']
    }else{
      ev['isSelected'] = true;
    }
    this.updateSelectionState();
  }

  onDismiss(flag) {
    //To check if configurable list (dropdown) is not present i.e. text is present
    if(this.inputs.length === 0)
      if (flag && this.isMandatory && isEmpty(this.selectedOtherItem?.trim())) return;

    if (!flag) {
      this.popoverCtrl.dismiss();
      return;
    }

    let payload = {
      inputs: this.selectedItem,
      selectedOtherItem: this.selectedOtherItem ? this.selectedOtherItem : null,
      role: 'ok'
    }
    if(this.enableMultiSelect){
      payload['selectedInputs'] = this.inputs.filter(a=> a['isSelected']);
    }

    this.popoverCtrl.dismiss(payload);

  }

  private isCustomFormFieldValid(): boolean {
    if (this.customFormField && this.customFormField.isMandatory) {
      if (this.customFormField.formFieldType === FormFieldType.INLINE_INPUT) {
        if (!this.customFormField.inputValue || this.customFormField.inputValue <= 0) {
          return false;
        }
      }
    }
    return true;
  }

  // private isTextInputValid(): boolean {
  //   if (this.inputs.length === 0) {
  //     return !isEmpty(this.selectedOtherItem);
  //   }
  //   return true;
  // }

  private isSelectionValid(): boolean {
    return !!this.selectedItem;
  }

  private isOthersDescriptionValid(): boolean {
    if (!this.requireDescriptionForOthers) {
      return true;
    }
    // Check if "Others" is selected in single select mode
    if (!this.enableMultiSelect) {
      if (this.selectedItem?.name === 'Others' || this.selectedItem === 'Others') {
        return !isEmpty(this.selectedOtherItem?.trim());
      }
      return true;
    }
    // Multi-select mode
    const selectedItems = this.inputs.filter(a => a?.isSelected);
    if (selectedItems.length === 0) {
      return true;  //if others is not selected, it doesnt have to be populated
    }
    // Check if "Others" is among selected items
    const hasOthers = selectedItems.some(item => item?.name === 'Others');
    if (hasOthers) {
      return !isEmpty(this.selectedOtherItem?.trim());
    }
    return true;
  }

  isConfirmButtonDisabled(): boolean {
    if (!this.isCustomFormFieldValid()) {
      return true;
    }
    if (!this.isMandatory) {
      return false;
    }
    if (this.inputs.length === 0) {
      return isEmpty(this.selectedOtherItem?.trim());
    }
    if (!this.isSelectionValid()) {
      return true;
    }
    return !this.isOthersDescriptionValid();
  }

  private updateSelectionState() {
    // Find any selected item
    let foundev = this.inputs.find(a => a['isSelected'] == true);
    if (foundev) {
      this.selectedItem = foundev;
      // Clear selectedOtherItem if non-"Others" is selected
      if (this.selectedItem != 'Others') {
        this.selectedOtherItem = null;
      }
    } else {
      this.selectedItem = null;
    }
    
    // Handle "Others" textbox
    if (this.inputs.find(a => a.name == "Others" && a.isSelected == true)) {
      this.enableOtherItemTextBox = true;
    } else {
      this.enableOtherItemTextBox = false;
    }
  }


  ngOnInit() {
    // Ensure the "Others" desc textbox is enabled if "Others" is already selected
    // const othersInput = this.inputs.find(a=> a.name == "Others" && a.isSelected == true);
    // if(othersInput){
    //   this.enableOtherItemTextBox = true;
    //   this.selectedItem = othersInput;
    // }else{
    //   this.enableOtherItemTextBox = false;
    // }
    this.updateSelectionState();
  }


  trackById(index: number, item: any) { return item?.id || item?.ID || index; }
}
